import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaSearch, FaAngleLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Helmet } from "react-helmet";
import { Config } from "../../Config";
import Preloader from "../../components/Preloader/Preloader";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Pagination from "../../components/Pagination/Pagination";
import BlogItem from "../../components/BlogItem/BlogItem";
import { getBlogs } from "../../Redux/Actions";
import NothingToShowBox from "../../components/NothingToShowBox/NothingToShowBox";
import "./Blog.scss";
import "./Responsive.scss";

const Blog = (props) => {
  const [blogFilterIcon, setBlogFilterIcon] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPage, setMaxPage] = useState();
  const [preloader, setPreloader] = useState(true);
  const [loaderCount, setLoaderCount] = useState(true);
  const [categories, setCategories] = useState([]);
  const [lastCategoryId, setLastCategoryId] = useState("");
  const [search, setSearch] = useState("");
  const [lastSearchKey, setLastSearchKey] = useState("");
  const user = useSelector((state) => state.user);
  const blogs = useSelector((state) => state.blogs);
  const dispatch = useDispatch();
  let searchKey;
  let categoryId;
  let checkForResetPage = false;
  if (props.location.state !== undefined) {
    if (props.location.state.categoryId !== null) {
      categoryId = props.location.state.categoryId;
      if (lastCategoryId != props.location.state.categoryId) {
        checkForResetPage = true;
      }
    }
    if (props.location.state.searchKey !== null) {
      searchKey = props.location.state.searchKey;
      if (
        props.location.state.searchKey !== "" &&
        props.location.state.searchKey !== undefined &&
        lastSearchKey !== props.location.state.searchKey
      ) {
        checkForResetPage = true;
      }
    }
  }

  const breadCrumbData = [
    { title: "خانه", link: "/" },
    { title: "خبرنامه", link: "/blog" },
  ];

  useEffect(async () => {
    if (checkForResetPage) {
      setCurrentPage(1);
      checkForResetPage = false;
    }

    setLastCategoryId(categoryId);
    setLastSearchKey(searchKey);

    Config.pageUp();

    await getBlogCategories();
    if (categoryId !== null && categoryId !== undefined) {
      filterByCategoryId();
      setLastSearchKey("");
      setSearch("");
    } else if (searchKey !== null && searchKey !== undefined) {
      filterBySearchKey(searchKey);
      setLastCategoryId("");
    } else {
      await getAllBlog();
      await getMaxPage(null, null);
    }
  }, [
    currentPage,
    props.location.state !== undefined && props.location.state.categoryId,
    props.location.state !== undefined && props.location.state.searchKey,
  ]);

  const getAllBlog = () => {
    setPreloader(true);
    if (loaderCount) {
      setLoaderCount(false);
    }
    axios
      .get(
        `/blog/getBlogs?page=${currentPage}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        dispatch(getBlogs(result.data.data));
        setPreloader(false);
      })
      .catch((error) => {
        // console.log(error);
        setPreloader(false);
      });
  };

  const getMaxPage = (key, categoryId) => {
    let adres;
    if (key !== null) {
      adres = `/blog/GetPages?page=${currentPage}&key=${key}`;
    } else if (categoryId !== null) {
      adres = `/blog/GetPages?page=${currentPage}&categoryId=${categoryId}`;
    } else {
      adres = "/blog/GetPages";
    }

    axios
      .get(
        adres,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setMaxPage(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getBlogCategories = () => {
    axios
      .get(
        "/blog/getCategories",
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        setCategories(result.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setPageHandler = (e) => {
    setCurrentPage(Number(e.target.innerText));
  };

  const nextPageHandler = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPageHandler = () => {
    setCurrentPage(currentPage - 1);
  };

  const filterByCategory = (categoryId) => {
    props.history.push({
      pathname: "/blog",
      state: { categoryId: categoryId, searchKey: null },
    });
    openMobileBlogTools();
  };

  const filterByCategoryId = () => {
    setPreloader(true);
    axios
      .get(
        `/blog/getBlogs?page=${currentPage}&categoryId=${categoryId}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        dispatch(getBlogs(result.data.data));
        getMaxPage(null, categoryId);
        setPreloader(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openMobileBlogTools = () => {
    let body = document.body;
    let mobileBlogLeftSidebar = document.querySelector(".blogLeftSidebar.mobile");
    let backdropBlog = document.querySelector(".backdropBlog");
    if (mobileBlogLeftSidebar.classList.contains("open")) {
      body.style.overflowY = "auto";
      backdropBlog.classList.remove("show");
      setBlogFilterIcon(true);
      mobileBlogLeftSidebar.classList.remove("open");
    } else {
      body.style.overflowY = "hidden";
      mobileBlogLeftSidebar.classList.add("open");
      backdropBlog.classList.add("show");
      setBlogFilterIcon(false);
    }
  };
  const closeBackdropBlog = () => {
    let body = document.body;
    let mobileBlogLeftSidebar = document.querySelector(".blogLeftSidebar.mobile");
    let backdropBlog = document.querySelector(".backdropBlog");
    if (mobileBlogLeftSidebar.classList.contains("open")) {
      body.style.overflowY = "auto";
      backdropBlog.classList.remove("show");
      setBlogFilterIcon(true);
      mobileBlogLeftSidebar.classList.remove("open");
    } else {
      body.style.overflowY = "hidden";
      mobileBlogLeftSidebar.classList.add("open");
      backdropBlog.classList.add("show");
      setBlogFilterIcon(false);
    }
  };

  const removeFilters = () => {
    setSearch("");
    props.history.push({
      pathname: `/blog`,
      state: { categoryId: null, searchKey: null },
    });
  };

  const searchHandler = (e) => {
    setSearch(e.target.value);
  };

  const searchOnEnter = (e) => {
    var keyCode = e.which || e.keyCode;
    if (keyCode === 13) {
      props.history.push({
        pathname: "/blog",
        state: { categoryId: null, searchKey: search },
      });
      // setSearch("");
    }
  };

  const submitSearchHandler = () => {
    props.history.push({
      pathname: "/blog",
      state: { categoryId: null, searchKey: search },
    });
  };

  const filterBySearchKey = (s) => {
    setPreloader(true);
    axios
      .get(
        `/blog/getBlogs?page=${currentPage}&key=${s !== undefined && s !== "" ? s : search}`,
        user[0]?.token && {
          headers: {
            Authorization: `Bearer ${user[0]?.token}`,
          },
        }
      )
      .then((result) => {
        dispatch(getBlogs(result.data.data));
        setPreloader(false);
        getMaxPage(s !== undefined && s !== "" ? s : search, null);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section className="blogWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | بلاگ</title> */}
        <title> {Config.helmetTitle} | بلاگ</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {/* {preloader && loaderCount && <Preloader active={preloader} />} */}
      <BreadCrumb breadCrumbData={breadCrumbData} />
      <div className="blogContents">
        <div className="desktop">
          <div className="blogLeftSidebar mobile">
            <div className="header">
              <div className="headerBox">
                <p className="title">جستجو</p>
                <p className="removeFilter" onClick={removeFilters}>
                  حذف فیلتر ها
                </p>
              </div>
              <div className="searchBox">
                <div className="searchForm">
                  <input
                    type="text"
                    className="searchInput"
                    value={search}
                    onChange={(e) => searchHandler(e)}
                    onKeyPress={searchOnEnter}
                    placeholder="جستجو کنید..."
                  />
                  <button className="btnSearch" onClick={submitSearchHandler}>
                    <FaSearch />
                  </button>
                </div>
              </div>
            </div>
            <div className="categoryList">
              <div className="header">
                <p className="title">دسته بندی ها</p>
              </div>
              <div className="categoryItems">
                {categories &&
                  categories.map((item, index) => {
                    return (
                      <span onClick={() => filterByCategory(item.id)} className="categoryItem" key={index}>
                        <FaAngleLeft /> {item.title}
                      </span>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="blogList">
            <div className="blogTools">
              <p className="title">لیست خبرنامه</p>
              <p className="pageCounter">
                صفحه {currentPage} از {maxPage}
              </p>
            </div>
            <div className="blogItems">
              {blogs.length > 0 ? (
                <BlogItem blogItemData={blogs} loading={preloader} />
              ) : (
                <NothingToShowBox
                  title="پستی برای نمایش وجود ندارد!"
                  note1="- برای جستجو از عبارت یا کلمات متداول تر استفاده نمایید"
                  note2="- برای بیشتر شدن دامنه پست های مورد نظر از فیلتر کمتر استفاده کنید "
                />
              )}
            </div>
            {maxPage > 1 && (
              <Pagination
                currentPage={currentPage}
                maxPage={maxPage}
                setPage={setPageHandler}
                next={nextPageHandler}
                prev={prevPageHandler}
              />
            )}
          </div>
          <div
            className="mobileBlogToolsButton"
            data-tooltip="جستجو و دسته بندی"
            data-tooltip-location="left"
            onClick={openMobileBlogTools}
          >
            {blogFilterIcon ? <FaBars /> : <FaTimes />}
          </div>
        </div>
      </div>
      <div className="backdropBlog" onClick={closeBackdropBlog}></div>
    </section>
  );
};

export default React.memo(Blog);
